import("../../../styles/components/information_card/information_card.css")

function InformationCard(options = {}){
    BaseConstructor.call(this)
    this.container='.information-card-container';
    let {size = ''} = options
    let context = this
    let listOfCards={};//lista de cards pré-definida
    let structure = {
        title: "title",
        text: "text",
        image: "image",
        subtitle: "subtitle"
    }
    this.generateCard = () =>{
        $(document.body).append(generateBaseStructure.call(this))
        $(this.container).addClass(size)
        eventsHandler()
    }
    this.updateCard = (options={}) =>{
        //handler das classes referentes a tema
        this.setTheme(options.theme)

        //alterando o título do card
        $(this.container).find('.'+structure.title).html(options.title)

        //alerando o subtitulo do card
        $(this.container).find('.'+structure.subtitle).html(options.subtitle)
        
        //alterando o texto do card
        $(this.container).find('.'+structure.text).html(options.text)
        
        //handler imagem do card
        this.setImage(options.image)

        //atualizando posição do card
        updatePosition.call(this,options.position)
    }
    this.show = () =>{
        $(this.container).addClass('show')
    }
    this.hide = () =>{
        $(this.container).removeClass('show')
    }
    this.addToListOfCards = (key, id, object)=>{
        listOfCards[key] = {}
        listOfCards[key][id] = object
    }
    this.getCard = (key, id) =>{
        try{
            return listOfCards[key][id]
        } catch(e){
            return false
        }
    }
    this.updatePosition = (data) =>{
        if(data instanceof HTMLElement){
            updatePositionByElement(data)
        } else if(typeof data === 'string'){
            updatePositionByString(data)
        } else {
            updatePosition(data)
        }
    }
    this.updateText = content =>{
        $(this.container).find('.'+structure.text).html(content)
    }
    this.updateTitle = content =>{
        $(this.container).find('.'+structure.title).html(content)
    }
    this.getContentContainer = _ =>{
        return $(this.container).find('.'+structure.text)[0]
    }
    this.setImage = (image) =>{
        if(image && image.url){
            //tem imagem, mostrar a div e alterar a imagem
            $(this.container).find('.'+structure.image).show()
            $(this.container).find('.'+structure.image).css("background-image", "url("+image.url+")")
        } else {
            //nao tem image, esconder div e remover current image
            $(this.container).find('.'+structure.image).hide()
            $(this.container).find('.'+structure.image).css("background-image", "url('')")
        }
    }
    this.setTheme = (theme) =>{
        //removendo outros temas
        $(this.container).removeClass('classic-theme user-theme')

        //adicionando classe tema
        $(this.container).addClass(theme+"-theme")
    }

    this.appendContent = content =>{
        $(this.container).append(content)
    }
    function generateBaseStructure(){
        return "<div class='"+this.container.replace(".","")+"'><div class='information-card'><div class='"+structure.image+"'></div>"+
        "<div class='"+structure.title+"'>TESTE</div><div class='"+structure.subtitle+"'></div><div class='text'>descrição</div></div></div>"
    }
    function updatePosition(position={}){
        $(this.container).css({"top": position.top, "left":position.left})
    }

    const eventsHandler = _ =>{
        $(this.container).on('animationend', () => {
            this.trigger('showend', this)
            // Your code to run when the animation ends
        });
    }

    const updatePositionByElement = element =>{
        let screen_width = window.innerWidth //width da tela
        let screen_height = window.innerHeight //height da tela
        let offset = $(element).offset() //offset do elemento de relação
        let element_width = $(element).width() //width do elemento de relação
        let card_width = $(context.container).width() //height do card
        let card_height = $(context.container).height() //widht do card

        let _left,_top

        if(offset.left + element_width + 10 + card_width < (screen_width-20)){
            //direita
            _left = offset.left + element_width + 10
        } else {
            //esquerda
            _left = offset.left - card_width - 10
        }

        if(offset.top + card_height < screen_height){
            //na mesma altura do elemento de relação
            _top = offset.top
        } else if(offset.top - card_height/2 > $('#main_header').height()){
            //no meio do elemento de relação
            _top = offset.top - card_height/2
        } else {
            //do elemento de relação pra cima
            _top = $('#main_header').height() + 10
        }

        $(context.container).css({
            left:_left,
            top: _top
        })
    }
    const updatePositionByString = string =>{
        if(string === 'center' || string === 'CENTER'){
            $(context.container).css({
                left:'50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
            })
        }
    }
}
InformationCard.prototype = Object.create(BaseConstructor.prototype)
export default InformationCard